import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "size-panel" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "custom-row" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "dim" }
const _hoisted_7 = {
  key: 0,
  class: "empty"
}

import { ref, computed, } from 'vue'
import { ElInput, ElButton, ElSelect, ElOption, ElScrollbar, ElIcon } from 'element-plus'
import { Search, RefreshRight } from '@element-plus/icons-vue'
import { createDesign } from '@/api/affairs'
import { getSystomDpi, mm2px } from '@/common/tool'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'size',
  props: {
    type: {
        type: String,
        default: ''
    }
},
  emits: ["create"],
  setup(__props, { emit: __emit }) {

const searchKeyword = ref('')
const width = ref<number | null>(500)
const height = ref<number | null>(500)
const unit = ref<'px' | 'cm' | 'mm' | 'in'>('px')
const props = __props
const userStore = useUserStore()
const presets = ref([
    { name: '手机海报', w: 1242, h: 2208, unit: 'px' },
    { name: '横版海报', w: 900, h: 500, unit: 'px' },
    { name: '小红书配图', w: 1242, h: 1656, unit: 'px' },
    { name: '公众号首页图', w: 900, h: 383, unit: 'px' },
    { name: '公众号次图', w: 500, h: 500, unit: 'px' },
    { name: '文章长图', w: 1000, h: 1500, unit: 'px' },
    { name: 'PPT (16:9)', w: 1920, h: 1080, unit: 'px' },
    { name: '竖版直播背景', w: 1242, h: 2690, unit: 'px' },
    { name: '竖版视频封面', w: 1242, h: 2208, unit: 'px' },
    { name: '横版视频封面', w: 1920, h: 1080, unit: 'px' },
    { name: '商品主图', w: 800, h: 800, unit: 'px' },
    { name: '电商详情页', w: 750, h: 1000, unit: 'px' },
    { name: 'PC端广告首页', w: 1920, h: 150, unit: 'px' },
    { name: '手机端广告首页', w: 750, h: 1000, unit: 'px' },
    { name: '店招', w: 1920, h: 150, unit: 'px' },
    { name: '电商横版海报', w: 750, h: 930, unit: 'px' },
    { name: '电商竖版海报', w: 750, h: 950, unit: 'px' },
    { name: '电商全版海报', w: 1920, h: 700, unit: 'px' },
    { name: '日签', w: 1242, h: 2208, unit: 'px' },
    { name: '小程序封面图', w: 520, h: 416, unit: 'px' },
])

const filteredList = computed(() => {
    const k = searchKeyword.value.trim().toLowerCase()
    if (!k) return presets.value
    return presets.value.filter(p =>
        p.name.toLowerCase().includes(k) || `${p.w}x${p.h}${p.unit}`.includes(k)
    )
})

const swapWH = () => {
    const w = width.value
    width.value = height.value
    height.value = w
}

const applyPreset = (p: { w: number; h: number; unit: 'px' | 'cm' | 'mm' | 'in'; name: string }) => {
    width.value = p.w
    height.value = p.h
    unit.value = p.unit
    onCreate()
}

const emit = __emit

const onCreate = async () => {
    if (userStore.isLoggedIn) {
        let h = height.value || 0
        let w = width.value || 0
        let dpi = 72
        if (unit.value == 'cm') {
            //@ts-ignore
            // dpi = getSystomDpi(w, h, 1)
            w = mm2px(w * 10, dpi)
            h = mm2px(h * 10, dpi)
        }
        if (unit.value == 'mm') {
            //@ts-ignore
            // dpi = getSystomDpi(w, h, 2)
            w = mm2px(w, dpi)
            h = mm2px(h, dpi)
        }
        const res = await createDesign({
            height: h,
            template_id: 0,
            name: '未命名模板',
            width: w,
        })
        localStorage.setItem('pk', String(res.data?.data?.pk ?? ''))
        localStorage.setItem('createNewTemplateDpi', String(dpi))
        const params = new URLSearchParams({
            id: String(res.data?.data?.pk ?? ''),
            mode: 'user',
            type: props.type,
        })
        emit('create', { width: w, height: h, unit: unit.value, id: res.data?.data?.pk })
        window.open(`/editor?${params.toString()}`, '_blank')
    } else {
        const params = new URLSearchParams({
            mode: 'create',
            category_id: '0',
            type: 'poster',
            width: String(width.value ?? ''),
            height: String(height.value ?? ''),
            unit: String(unit.value),
        })
        emit('create', { width: width.value || 0, height: height.value || 0, unit: unit.value, id: null })
        window.open(`/editor?${params.toString()}`, '_blank')
    }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header" }, "创建设计", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ElInput), {
        modelValue: searchKeyword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKeyword).value = $event)),
        "prefix-icon": _unref(Search),
        placeholder: "搜索全部尺寸",
        clearable: ""
      }, null, 8, ["modelValue", "prefix-icon"])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title" }, "自定义尺寸", -1)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(ElInput), {
        modelValue: width.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((width).value = $event)),
        modelModifiers: { number: true },
        placeholder: "宽",
        class: "wh-input"
      }, null, 8, ["modelValue"]),
      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "x" }, "×", -1)),
      _createVNode(_unref(ElInput), {
        modelValue: height.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((height).value = $event)),
        modelModifiers: { number: true },
        placeholder: "高",
        class: "wh-input"
      }, null, 8, ["modelValue"]),
      _createVNode(_unref(ElSelect), {
        modelValue: unit.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((unit).value = $event)),
        class: "unit-select",
        style: {"margin":"0 10px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElOption), {
            label: "px",
            value: "px"
          }),
          _createVNode(_unref(ElOption), {
            label: "cm",
            value: "cm"
          }),
          _createVNode(_unref(ElOption), {
            label: "mm",
            value: "mm"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_unref(ElButton), {
        type: "primary",
        class: "create-btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onCreate())),
        style: {"background-color":"#2a66ff"}
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
          _createTextVNode("创建", -1)
        ]))]),
        _: 1
      })
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "section-title mt-12" }, "系统推荐尺寸", -1)),
    _createVNode(_unref(ElScrollbar), { class: "list-wrap" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.name,
            class: "size-item cursor-pointer",
            onClick: ($event: any) => (applyPreset(item))
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.w) + " × " + _toDisplayString(item.h) + " " + _toDisplayString(item.unit), 1)
          ], 8, _hoisted_4))
        }), 128)),
        (filteredList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "未找到匹配尺寸"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})